import styled from 'styled-components';

const Input = styled.input`
    ${props => props}
    outline: none;
    border: ${props => `1px solid ${props.theme.old.colors.transparent}`};
    background-color: ${props => props.theme.old.colors[props.bg] || props.theme.old.colors.maWhite};
    padding: ${props => props.padding || '12px 16px'};
    border-radius: ${props => props.theme.old.rounded[props.rounded] || props.theme.old.rounded.sm};
    width: ${props => props.width || '100%'};
    height: 48px;
    max-width: 100%;
    transition: ${props => props.theme.old.transition.default};
    font-family: ${props => props.theme.old.fonts.family.primary};
    font-size: ${props => props.theme.old.fontSize.text};
    color: ${props => props.theme.old.colors.lightBlack};

    :hover {
        background-color: ${props => props.theme.old.colors[props.hoverBg] || props.theme.old.colors.bleachedSilk};
    }

    :focus {
        background-color: ${props => props.theme.old.colors[props.focusBg] || props.theme.old.colors.white};
        border: ${props => `1px solid ${props.theme.old.colors[props.focusBorder] || props.theme.old.colors.sweetScape}`};
    }

    :active {
        background-color: ${props => props.theme.old.colors[props.focusBg] || props.theme.old.colors.white};
        border: ${props => `1px solid ${props.theme.old.colors[props.focusBorder] || props.theme.old.colors.sweetScape}`};
    }

    :not(:placeholder-shown) {
        background-color: ${props => props.theme.old.colors[props.focusBg] || props.theme.old.colors.white};
        border: ${props => `1px solid ${props.theme.old.colors[props.focusBorder] || props.theme.old.colors.sweetScape}`};
        color: ${props => props.theme.old.colors[props.color]};
    }
`;

Input.defaultProps = {
    type: 'text',
    autocomplete: 'off'
}

export default Input;
